import { css } from '@emotion/react';
import { textMediumLineHeight } from 'styles/global_defaults/fonts';
import { MentoringProgramRole } from 'redux/schemas/models/mentoring-program-enrollments';

import ParticipantDot from 'athena/components/participant-dot';

const participantDotStyles = css`
  line-height: ${textMediumLineHeight}px;
`;

type ParticipantDotProps = {
  role: MentoringProgramRole;
  alias: string;
};

const ParticipantDotAlias = ({ role, alias }: ParticipantDotProps) => (
  <div
    css={participantDotStyles}
    className='mentee-status d-flex align-items-center pt-2 pb-1'
  >
    <ParticipantDot role={role} className='mr-1' />
    <div className='status-text semi-bold gray-2 align-items-center justify-content-center'>
      {alias}
    </div>
  </div>
);

export default ParticipantDotAlias;
